// Filename - components/Sidebar.js

// import React, { useState } from "react";
// import styled from "styled-components";
// import * as FaIcons from "react-icons/fa";
// import { IconContext } from "react-icons/lib";

// Filename - components/Sidebar.js

import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import {Outlet, Link, useFetcher } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import { Settings as SettingsIcon } from '@mui/icons-material';

import {alpha, Box } from '@mui/system';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import axios from 'axios';


import "../components/Scrollbar.css";
import { SidebarData } from "../components/SidebarData";
import SubMenu from "../components/SubMenu";
import AirportSearch from "../components/AirportSearch"
import SummaryBox from "../components/SummaryBox";
import EpochSlider from "../components/EpochSlider";

import Badge from '@mui/material/Badge';
import { authService } from '../services/authService';
import { notificationService } from '../services/notificationService';
import { IconButton, Tooltip, Menu, MenuItem, Typography, Dialog, DialogTitle, DialogContent, Slider, Divider } from '@mui/material';
import { AccountCircle, ExitToApp, Login, Email, ContentCopy } from '@mui/icons-material';


const SUPPORT_MAIL_ID = "AviationSafety@robust-analytics.com"
const Nav = styled.div`
    position:relative;
    background: #275AA6;
    min-height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index:30;
`;

const AirportPullDown=styled.div`
    width: 50px;
    height: 20px;
    background: rgba(233, 239, 247);
    display:flex;
    z-index:0;
    justify-content:center;
    boxShadow: '1px 1px 1px rgba(0, 0, 0, 0.25)';
    &:hover{
        boxShadow: '0px 0px 1px rgba(0, 0, 0, 0.35)';
        background:#B0C4E0;
        cursor: pointer;
        transform: perspective(1px) rotateX(-1deg) ${({ sidebar,activeAirport,revealFlag }) => ((sidebar||(activeAirport==='')||revealFlag) ? "translateY(-100%)" : "translateY(0)")};
    }
    border-radius: 3px;
    padding-top:-221px;
    margin-bottom:-10px;
    transform: perspective(1px) rotateX(-1deg) ${({ sidebar,activeAirport,revealFlag }) => ((sidebar||(activeAirport==='')||revealFlag) ? "translateY(-100%)" : "translateY(-20%)")};
    transform-origin: top;
    transition: 950ms ease, opacity 900ms linear;
`;

const AirportPullUp = styled.div`
    position:absolute;
    width: 50px;
    height: 20px;
    background: rgba(233, 239, 247,0);
    display:${({ revealFlag }) => (revealFlag ? "none" : "flex")};
    z-index:2;
    justify-content:center;
    boxShadow: '1px 1px 1px rgba(0, 0, 0, 0.25)';
    &:hover{
        boxShadow: '0px 0px 1px rgba(0, 0, 0, 0.35)';
        background:rgba(201, 219, 242);
        cursor: pointer;
    }
    border-radius: 3px;
    bottom:0;
    margin-top:30px;
    transform: perspective(1px) rotateX(1deg);
    transform-origin: bottom;
    transition: 900ms ease, opacity 900ms ease;
`;

const AirportSwipeStyle=styled.div`
    position:absolute;
    width: 30px;
    vertical-align:middle;
    height: 50px;
    background: rgba(233, 239, 247,0);
    z-index:0;
    boxShadow: '1px 1px 1px rgba(0, 0, 0, 0.25)';
    &:hover{
        boxShadow: '0px 0px 1px rgba(0, 0, 0, 0.35)';
        background:rgba(201, 219, 242);
        cursor: pointer;
    }
    border-radius: 3px;
    display:flex;
    justify-content:center;
    align-items:center;
    left:${({direction}) => (direction==='left' ? '10px' : 'calc(100%-10px)')};
    right:${({direction}) => (direction==='right' ? '10px' : 'calc(100%-10px)')};
    transition: 350ms ease, opacity 350ms ease;
`;

const AirportCarousel=styled.div`
    height: 40px;
    width:100%;
    background: rgba(228, 235, 245);
    display:flex;
    z-index:0;
    overflow:scroll;
    justify-content:center;
    boxShadow: '1px 1px 1px rgba(0, 0, 0, 0.25)';
    border-radius: 3px;
    padding-top:-221px;
    margin-bottom:${({selectedMetricIndex,revealFlag,sidebar}) => ((selectedMetricIndex!==0)&&revealFlag&&!sidebar ? "-30px" : "-22px")};
    transform: ${({selectedMetricIndex,revealFlag,sidebar}) => ((selectedMetricIndex!==0)&&revealFlag&&!sidebar ? "translateY(-25%)" : "translateY(-120%)")};
    transform-origin: top;
    transition: 900ms ease, opacity 900ms ease;   
`;

const AirportListDiv=styled.div`
    display:flex;
    width:95%;
    margin-top:5px;
    overflow:hidden;
    margin-left:${({carouselDirection}) => (carouselDirection>0?"100px":"-100px")};
`;

const AppNameDiv = styled(Link)`
    text-align:left;
    margin-left:0.2rem;
    color:#C8D5F5;
    -webkit-user-select: none; 
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    
    display: flex;
    width:350px;
    height:40px;
    margin-top:5px;
    margin-bottom:5px;
    align-items: center;
    text-decoration: none;
    &:hover {
        cursor: pointer;
    }
`;
const AppName = styled.div`
    font-size: 1.5rem;
    font-weight:bold;
    margin-top:5px;
    margin-bottom: -3px;
`;

const NavLeft = styled.div`
    background: #275AA6;
    min-height: 50px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    margin-left:0.5rem;
`;

const NavRight = styled.div`
    background: #275AA6;
    height: 50px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    margin-right:1rem;
`;
// const NavCollapse=styled.div`
//     background: #DCE8F7;
//     display:inline-block;
// `;

const NavIconOpen = styled(Link)`
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    padding-left:0px;
    padding-right:0px;
    font-size: 2rem;
    height: 40px;
    display: flex;
    color:#C8D5F5;
    background: #275AA6;
    justify-content: flex-end;
    align-items: center;
`;

// const NavIconClose = styled(Link)`
//     padding-left:10px;
//     padding-right:10px;
//     font-size: 2rem;
//     height: 50px;
//     display: flex;
//     background: #DCE8F7;
//     color:#C8D5F5;
//     justify-content: flex-end;
//     align-items: center;
// `;

const SidebarNav = styled.nav`
    background: #DCE8F7;
    width: 250px;
    height: calc(100% - 50px);
    display: flex;
    
    justify-content: right;
    position: fixed;
    margin-top:50px;
    top: 0;
    left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
    transition: 350ms;
    z-index: 10;
    overflow-y: scroll;
`;

const AirportBox = styled.div`
    width:100%;
    
`;
    
const AirportListBox = styled.div`
    display:flex;
    height:100px;
    flex: 0 1 auto;
    flex-direction:column;
    overflow-y: scroll;
`;

const NotificationElementDiv = styled.div`
    display: flex;
    align-items: center;
    padding: 12px 16px;
    min-height: 48px;
    border-bottom: 1px solid #f0f0f0;
    transition: all 0.2s ease;
    position: relative;
    background-color: ${props => props.isLatest ? 'white' : '#f5f5f5'};
    
    &:last-child {
        border-bottom: none;
    }
    
    &:hover {
        background-color: #f8f9fa;
        cursor: pointer;
    }
    
    a {
        flex: 1;
        text-decoration: none;
        color: #333;
        
        &:hover {
            color: #275AA6;
        }
    }
`;

const NotificationElement =({clickFunc,notificationDataElem,key,isLatest})=>{
    const [isHovered,setIsHovered] = useState(false)
    const status = notificationDataElem.status || 'completed';
    const hasDownloadLink = notificationDataElem.downloadLink || notificationDataElem.download_link;
    
    // Status styling
    const getStatusColor = (status) => {
        switch(status) {
            case 'processing': return '#ff9800';
            case 'completed': return '#4caf50';
            case 'failed': return '#f44336';
            default: return '#2196f3';
        }
    };
    
    const getStatusIcon = (status) => {
        switch(status) {
            case 'processing': return '⏳';
            case 'completed': return '✅';
            case 'failed': return '❌';
            default: return 'ℹ️';
        }
    };
    
    return(<NotificationElementDiv isLatest={isLatest}>
        <div style={{ marginRight: '8px', fontSize: '16px' }}>
            {getStatusIcon(status)}
        </div>
        {hasDownloadLink ? (
            <a href={hasDownloadLink} download>
                <div style={{ 
                    fontSize: '14px',
                    lineHeight: '1.4',
                    paddingRight: '8px'
                }}>
                    <div>{notificationDataElem.text || notificationDataElem.title}</div>
                    {notificationDataElem.message && (
                        <div style={{ 
                            fontSize: '12px', 
                            color: '#666', 
                            marginTop: '2px' 
                        }}>
                            {notificationDataElem.message}
                        </div>
                    )}
                </div>
            </a>
        ) : (
            <div style={{ 
                fontSize: '14px',
                lineHeight: '1.4',
                paddingRight: '8px',
                flex: 1,
                color: status === 'failed' ? '#f44336' : '#333'
            }}>
                <div>{notificationDataElem.text || notificationDataElem.title}</div>
                {notificationDataElem.message && (
                    <div style={{ 
                        fontSize: '12px', 
                        color: status === 'failed' ? '#f44336' : '#666', 
                        marginTop: '2px' 
                    }}>
                        {notificationDataElem.message}
                    </div>
                )}
            </div>
        )}
        <div  
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={clickFunc}
            style={{
                padding: '4px',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s ease',
                backgroundColor: isHovered ? '#f0f0f0' : 'transparent'
            }}
        >  
            <FaIcons.FaTimes 
                size={14}
                color={isHovered ? "#275AA6" : "#999"}
                style={{ cursor: 'pointer' }}
            />
        </div>
    </NotificationElementDiv>)
}

const NotificationClearButton = ({clickFunc}) =>{
    const [isHovered,setIsHovered] = useState(false)
    return(<div style={{
        padding: '12px 16px',
        textAlign: 'center',
        borderBottom: '1px solid #f0f0f0',
        backgroundColor: '#f8f9fa',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
    }}
    onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}
    onClick={clickFunc}
    >
        <div style={{
            fontSize: '12px',
            fontWeight: '600',
            color: isHovered ? "#1976d2" : "#275AA6",
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
        }}>
            Clear All
        </div>
    </div>);
};

const SearchBoxDiv=styled.div`
    display: flex;
    color:black;
    background:#DCE8F7;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    list-style: none;
    height: 60px;
    text-decoration: none;
    font-size: 18px;
`;

const SidebarWrap = styled.div`
    width: 100%;
`;
const MasterLayout = styled.div`
    display:flex;
    
    
`;
const ContentLayout = styled.div`
    display:flex;
    background:white;
    justify-content: flex-start;
    flex:1;
    margin-left: ${({ sidebar }) => (sidebar ? "270px" : "20px")};
    margin-top: ${({revealFlag,selectedMetricIndex}) => (revealFlag&&(selectedMetricIndex!==0) ? "20px": "-20px")};
    transition: 350ms;
`;



// const ContentLayout = styled.div`
    // margin-top:10px;
    // margin-left:10px;
    // margin-right:10px;
    // margin-bottom:10px;
    // display:flex;
    // background:white;
    // justify-content: flex-start;
    // flex-wrap:wrap;
    // flex:1;
    // gap:10px 10px;
    // margin-left: ${({ sidebar }) => (sidebar ? "270px" : "20px")};
    // transition: 350ms;
// `;

const BannerPageTitle = styled.h1`
  font-size: 1.5em;
  text-align: center;
  margin-left:-150px;
  color: #FFF;
`;

const NotificationPanelDiv = styled.div`
    min-width: 320px;
    max-width: 380px;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 1000;
    position: absolute;
    right: 10px;
    top: 50px;
    background: white;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12), 0px 2px 8px rgba(0, 0, 0, 0.08);
    padding: 0;
    
    /* Custom scrollbar */
    &::-webkit-scrollbar {
        width: 6px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }
`;
const NavLayout = ({sidebar,showSidebar,pageTitle,airportDataList,setActiveMetric,setActiveAirport,activeMetric,activeAirport,enabledAirports,
                    summaryMetricIndex,summaryMetricName,setMetricSelectedIndex,selectedMetricIndex,notificationData,setNotificationData,backendApiPrefix,
                    currentUser, setColoringThresholds, children}) => {
    // const [sidebar, setSidebar] = useState(true);
    // const showSidebar = () => setSidebar(!sidebar);
    const [selectedAirportIndex, setAirportSelectedIndex] = useState(null);
    const [isHovered,setIsHovered]  = useState(false);
    const [toggleNotificationOpen,setToggleNotificationOpen] = useState(false)
    const [displayNotificationData,setDisplayNotificationData] = useState([])
    const [userMenuAnchorEl, setUserMenuAnchorEl] = useState(null);
    const [settingsOpen, setSettingsOpen] = useState(false);
    const [redThreshold, setRedThreshold] = useState(95);
    const [orangeThreshold, setOrangeThreshold] = useState(80);
    const notificationPanelRef = useRef(null);
    const bellIconRef = useRef(null);
    
    
    const handleMetricClick = (index) => {
        setMetricSelectedIndex(index);
        console.log("CLICK")
        if(Object.hasOwn(enabledAirports,activeMetric)&&(!enabledAirports[activeMetric].includes(activeAirport))){
            setActiveAirport('')
        }
      };
    
           
    const handleAirportClick = (index) => {
        setAirportSelectedIndex(index);
      };

    const [showAirportCarouselFlag,setShowAirportCarouselFlag] = useState(false)    
    useEffect(()=>{
        if(sidebar){
            setShowAirportCarouselFlag(false)
        }

    },[sidebar]);
    const handleAirportPullUpClick=()=>{
        setShowAirportCarouselFlag(false)
    };
    const handleAirportPullDownClick=()=>{
        setShowAirportCarouselFlag(true)
    };

    const handleClickOnAirport=(airport)=>{
        setActiveAirport(airport)
        setActiveMetric(activeMetric)
    }

    const handleLogoClick=()=>{
        setActiveAirport('');
        setActiveMetric('');
        setMetricSelectedIndex(0);
        setAirportSelectedIndex(null);
    }
    const clearNotification = async (idx) => {
        const notification = notificationData[idx];
        
        if (currentUser?.attributes?.email && notification.id) {
            // Delete from backend
            const result = await notificationService.deleteNotification(
                notification.id, 
                currentUser.attributes.email
            );
            
            if (result.success) {
                // Remove from local state
                const newNotifications = [...notificationData];
                newNotifications.splice(idx, 1);
                setNotificationData(newNotifications);
                
                if (newNotifications.length === 0) {
                    setToggleNotificationOpen(false);
                }
            }
        } else {
            // Guest user - use localStorage
            const newNotifications = [...notificationData];
            newNotifications.splice(idx, 1);
            setNotificationData(newNotifications);
            
            if (newNotifications.length === 0) {
                setToggleNotificationOpen(false);
            }
        }
    };

    const markAllNotificationsAsRead = async () => {
        if (currentUser?.attributes?.email) {
            // Mark all unread notifications as read
            const unreadNotifications = notificationData.filter(notif => !notif.isRead);
            
            for (const notification of unreadNotifications) {
                if (notification.id) {
                    await notificationService.markNotificationAsRead(notification.id, currentUser.attributes.email);
                }
            }
            
            // Update local state to mark all as read
            const updatedNotifications = notificationData.map(notif => ({
                ...notif,
                isRead: true
            }));
            setNotificationData(updatedNotifications);
        }
    };

    const clearAllNotifications = async () => {
        console.log('clearAllNotifications called, current user:', !!currentUser?.attributes?.email);
        if (currentUser?.attributes?.email) {
            // Clear from backend
            console.log('Clearing notifications from backend for user:', currentUser.attributes.email);
            const result = await notificationService.clearAllNotifications(currentUser.attributes.email);
            console.log('Backend clear result:', result);
            if (result.success) {
                console.log('Backend clear successful, clearing local state');
                setNotificationData([]);
                setToggleNotificationOpen(false);
            } else {
                console.error('Backend clear failed:', result);
            }
        } else {
            // Guest user - clear localStorage by calling setNotificationData with empty array
            // This will handle localStorage through setNotificationDataCache in App.js
            console.log('Clearing notifications for guest user');
            setNotificationData([]);
            setToggleNotificationOpen(false);
            // Note: localStorage is handled by setNotificationDataCache in App.js
        }
    };
    // const noNotificationDiv = <NotificationElementDiv style={{marginLeft:10}}>No notifications</NotificationElementDiv>
    
    useEffect(()=>{
        setDisplayNotificationData(notificationData.map((item,index) => {
                return(<NotificationElement key={index} clickFunc={() => clearNotification(index)} 
                notificationDataElem={item} isLatest={index === 0}/>);
            }))
        
    },[notificationData])

    // Handle click outside notification panel to close it
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (toggleNotificationOpen && 
                notificationPanelRef.current && 
                !notificationPanelRef.current.contains(event.target) &&
                bellIconRef.current &&
                !bellIconRef.current.contains(event.target)) {
                setToggleNotificationOpen(false);
            }
        };

        if (toggleNotificationOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [toggleNotificationOpen]);


    const handleUserMenuClick = (event) => {
        setUserMenuAnchorEl(event.currentTarget);
    };

    const handleUserMenuClose = () => {
        setUserMenuAnchorEl(null);
    };

    const handleLogout = async () => {
        const result = await authService.signOut();
        if (result.success) {
            window.location.reload(); // Force reload to show login screen
        }
        handleUserMenuClose();
    };

    const handleSignIn = () => {
        // Navigate to the base auth page
        window.location.href = '/';
        handleUserMenuClose();
    };

    return (
        <>
            <IconContext.Provider value={{ color: "#fff" }}>
                <Nav>
                    <NavLeft>
                    <NavIconOpen to="#">
                    <FaIcons.FaBars style={{color:"#C8D5F5",marginTop:"0.3rem"}} size={27}
                    onClick={showSidebar} />
                    </NavIconOpen>
                    
                    <AppNameDiv to="/" onClick={handleLogoClick}>
                    <img src="https://web-app-support.s3.us-east-2.amazonaws.com/AviationSafetyMonitorLogo.png" alt="Logo"
                    style={{marginRight:'10px', maxWidth: '100%',maxHeight: '95%',objectFit:'contain'}}/>
                    <div style={{marginBottom:'10px'}}>
                    <AppName>Risk Tracker</AppName>
                    <p style={{fontSize:14}}>A service of the Aviation Safety Monitor</p>
                    </div>
                    </AppNameDiv>
                    
                    </NavLeft>
                    <BannerPageTitle>{pageTitle}</BannerPageTitle>
                    <NavRight>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {currentUser ? (
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', color: '#C8D5F5' }}>
                                <Typography variant="body2" sx={{ fontSize: '0.85rem', fontWeight: 'medium', lineHeight: 1.2 }}>
                                    {currentUser?.attributes?.name||''}
                                </Typography>
                                <Typography variant="caption" sx={{ fontSize: '0.75rem', opacity: 0.8, lineHeight: 1.2 }}>
                                    {currentUser?.attributes?.email||''}
                                </Typography>
                            </Box>
                        ) : (
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', color: '#C8D5F5' }}>
                                <Typography variant="body2" sx={{ fontSize: '0.85rem', fontWeight: 'medium', lineHeight: 1.2 }}>
                                    Guest User
                                </Typography>
                                <Typography 
                                    variant="caption" 
                                    onClick={handleUserMenuClick}
                                    sx={{ 
                                        fontSize: '0.75rem', 
                                        opacity: 0.8, 
                                        lineHeight: 1.2,
                                        cursor: 'pointer',
                                        '&:hover': {
                                            opacity: 1,
                                            textDecoration: 'underline'
                                        }
                                    }}
                                >
                                    Click to sign in
                                </Typography>
                            </Box>
                        )}
                        <Tooltip title={currentUser ? "User Menu" : "Sign In"}>
                            <IconButton
                                onClick={handleUserMenuClick}
                                size="small"
                                sx={{ color: '#C8D5F5', marginLeft: 0.5,marginRight:-0.6 }}
                            >
                                <AccountCircle sx={{ fontSize: 32 }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Menu
                        anchorEl={userMenuAnchorEl}
                        open={Boolean(userMenuAnchorEl)}
                        onClose={handleUserMenuClose}
                        PaperProps={{
                            elevation: 3,
                            sx: { mt: 1.5, minWidth: 220 }
                        }}
                    >
                        {currentUser ? (
                            <div>
                                <MenuItem disabled>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                                        <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                                            {currentUser?.attributes?.email|| 'User'}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            {currentUser?.attributes?.name||''}
                                        </Typography>
                                    </Box>
                                </MenuItem>
                                <MenuItem onClick={handleLogout}>
                                    <ExitToApp sx={{ marginRight: 1 }} />
                                    Sign Out
                                </MenuItem>
                                <Divider />
                                <Tooltip title={SUPPORT_MAIL_ID} placement="left">
                                    <MenuItem onClick={() => window.location.href = `mailto:${SUPPORT_MAIL_ID}`}>
                                        <Email sx={{ marginRight: 1 }} />
                                        Contact Us
                                    </MenuItem>
                                </Tooltip>
                            </div>
                        ) : (
                            <div>
                                <MenuItem disabled>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                                        <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                                            Guest User
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            Viewing NAS-wide Summary
                                        </Typography>
                                    </Box>
                                </MenuItem>
                                <MenuItem onClick={handleSignIn}>
                                    <Login sx={{ marginRight: 1 }} />
                                    Sign In
                                </MenuItem>
                                <Divider />
                                <Tooltip title={SUPPORT_MAIL_ID} placement="left">
                                    <MenuItem onClick={() => window.location.href = `mailto:${SUPPORT_MAIL_ID}`}>
                                        <Email sx={{ marginRight: 1 }} />
                                        Contact Us
                                    </MenuItem>
                                </Tooltip>
                            </div>
                        )}
                    </Menu>
                    <Tooltip title="Settings">
                        <IconButton
                            onClick={() => setSettingsOpen(true)}
                            size="small"
                            sx={{ color: '#C8D5F5', marginLeft: 0 }}
                        >
                            <SettingsIcon sx={{ fontSize: 32 }} />
                        </IconButton>
                    </Tooltip>
                    <div style={{display:'flex',alignItems:'center',marginTop:5}}>
                    <Badge badgeContent={notificationData.filter(notif => !notif.isRead).length} color="primary"
                            sx={{'& .MuiBadge-badge': {
                            backgroundColor: '#c46692', // Custom color
                            color: 'white',
                            }}}>
                        <div  ref={bellIconRef}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            onClick={async () => {
                                if (notificationData.length > 0) {
                                    // Mark all notifications as read when bell is clicked
                                    await markAllNotificationsAsRead();
                                    setToggleNotificationOpen(!toggleNotificationOpen);
                                } else {
                                    setToggleNotificationOpen(false);
                                }
                            }}
                        >
                        <FaIcons.FaBell style={{color:isHovered?"#b4c0e0":"#C8D5F5",cursor:'pointer'}} size={28}/>
                    </div>
                    </Badge>
                    </div>
                    </NavRight>
                </Nav>
                <div style={{display:"flex",justifyContent:"center"}}>
                <AirportPullDown sidebar={sidebar} revealFlag={showAirportCarouselFlag} activeAirport={activeAirport} onClick={handleAirportPullDownClick}><FaIcons.FaAngleDown style={{color:"#595959"}}/></AirportPullDown>
                </div>
                {toggleNotificationOpen&&<NotificationPanelDiv ref={notificationPanelRef}>
                        <div style={{
                            padding: '16px',
                            borderBottom: '1px solid #f0f0f0',
                            backgroundColor: 'white',
                            borderRadius: '8px 8px 0 0'
                        }}>
                            <div style={{
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#333',
                                marginBottom: '4px'
                            }}>
                                Notifications
                            </div>
                            <div style={{
                                fontSize: '12px',
                                color: '#666'
                            }}>
                                {notificationData.length === 0 ? 'No notifications' : `${notificationData.filter(notif => !notif.isRead).length} unread of ${notificationData.length} total`}
                            </div>
                        </div>
                        
                        {notificationData.length > 0 ? (
                            <>
                                <NotificationClearButton clickFunc={clearAllNotifications}/>
                                {displayNotificationData}
                            </>
                        ) : (
                            <div style={{
                                padding: '32px 16px',
                                textAlign: 'center',
                                color: '#999',
                                fontSize: '14px'
                            }}>
                                <div style={{ marginBottom: '8px' }}>📭</div>
                                <div>No notifications yet</div>
                                <div style={{ fontSize: '12px', marginTop: '4px' }}>
                                    Downloads and updates will appear here
                                </div>
                            </div>
                        )}
                    </NotificationPanelDiv>}
                <Dialog 
                    open={settingsOpen} 
                    onClose={() => setSettingsOpen(false)}
                    maxWidth="sm"
                    fullWidth
                    PaperProps={{
                        sx: {
                            borderRadius: '12px',
                            boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.16)'
                        }
                    }}
                >
                    <DialogTitle sx={{ 
                        fontSize: '1.25rem', 
                        fontWeight: 600, 
                        pb: 1,
                        borderBottom: '1px solid #f0f0f0'
                    }}>
                        Safety Risk Score Settings
                    </DialogTitle>
                    <DialogContent sx={{ py: 3 }}>
                        <br/>
                        <Box sx={{ mb: 4 }}>
                            <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: '#333' }}>
                                Red Threshold: {redThreshold}th Percentile
                            </Typography>
                            <Slider
                                value={redThreshold}
                                onChange={(e, newValue) => {
                                    if (newValue >= orangeThreshold) {
                                        setRedThreshold(newValue);
                                        setColoringThresholds({'RED': `${newValue}Perc`, 'ORANGE': `${orangeThreshold}Perc`});
                                    }
                                }}
                                valueLabelDisplay="auto"
                                step={null}
                                marks={[
                                    { value: 50, label: '50th' },
                                    { value: 75, label: '75th' },
                                    { value: 80, label: '80th' },
                                    { value: 85, label: '85th' },
                                    { value: 90, label: '90th' },
                                    { value: 95, label: '95th' },
                                    { value: 99, label: '99th' }
                                ]}
                                min={50}
                                max={99}
                                sx={{
                                    color: '#d32f2f',
                                    '& .MuiSlider-thumb': {
                                        backgroundColor: '#d32f2f',
                                    },
                                    '& .MuiSlider-track': {
                                        backgroundColor: '#d32f2f',
                                    },
                                    '& .MuiSlider-rail': {
                                        backgroundColor: '#e0e0e0',
                                    },
                                    '& .MuiSlider-mark': {
                                        backgroundColor: '#d32f2f',
                                    },
                                    '& .MuiSlider-markLabel': {
                                        fontSize: '0.75rem',
                                    }
                                }}
                            />
                        </Box>
                        <Box>
                            <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: '#333' }}>
                                Orange Threshold: {orangeThreshold}th Percentile
                            </Typography>
                            <Slider
                                value={orangeThreshold}
                                onChange={(e, newValue) => {
                                    if (newValue <= redThreshold) {
                                        setOrangeThreshold(newValue);
                                        setColoringThresholds({'RED': `${redThreshold}Perc`, 'ORANGE': `${newValue}Perc`});
                                    }
                                }}
                                valueLabelDisplay="auto"
                                step={null}
                                marks={[
                                    { value: 50, label: '50th' },
                                    { value: 75, label: '75th' },
                                    { value: 80, label: '80th' },
                                    { value: 85, label: '85th' },
                                    { value: 90, label: '90th' },
                                    { value: 95, label: '95th' },
                                    { value: 99, label: '99th' }
                                ]}
                                min={50}
                                max={99}
                                sx={{
                                    color: '#ff9800',
                                    '& .MuiSlider-thumb': {
                                        backgroundColor: '#ff9800',
                                    },
                                    '& .MuiSlider-track': {
                                        backgroundColor: '#ff9800',
                                    },
                                    '& .MuiSlider-rail': {
                                        backgroundColor: '#e0e0e0',
                                    },
                                    '& .MuiSlider-mark': {
                                        backgroundColor: '#ff9800',
                                    },
                                    '& .MuiSlider-markLabel': {
                                        fontSize: '0.75rem',
                                    }
                                }}
                            />
                        </Box>
                    </DialogContent>
                </Dialog>
                <AirportCarousel sidebar={sidebar} selectedMetricIndex={selectedMetricIndex} revealFlag={showAirportCarouselFlag}>
                    {/* <AirportSwipeStyle direction="left" onClick={handlePrev}><FaIcons.FaAngleLeft style={{color:"#595959"}}/></AirportSwipeStyle> */}
                    <AirportPullUp onClick={handleAirportPullUpClick}><FaIcons.FaAngleUp style={{color:"#595959"}}/></AirportPullUp>
                    {/* <AirportSwipeStyle direction="right" onClick={handleNext}><FaIcons.FaAngleRight style={{color:"#595959"}}/></AirportSwipeStyle> */}
                    {Object.keys(airportDataList).map((airport,index) => {
                            return(
                                <Button style={{textAlign:'center',textDecoration:'none',fontSize:'0.8em',minHeight:'36px',maxHeight:'36px',maxWidth:'56px',minWidth:'56px',paddingRight:'0px',paddingLeft:'0px',paddingTop:'0px',paddingBottom:'4px'}}
                                        key={index}
                                        variant="text" color={(airport===activeAirport)?"warning":"primary"} 
                                        disabled={!Object.hasOwn(enabledAirports,activeMetric)||(Object.hasOwn(enabledAirports,activeMetric)&&enabledAirports[activeMetric].includes(airport))?false:true}
                                        component={Link} to={"/metrics/"+activeMetric+"/"+airport}
                                        onClick={()=>{handleClickOnAirport(airport)}}>
                                            {airport}
                                </Button>
                            );
                        })}
                </AirportCarousel>
                <MasterLayout>
                    <SidebarNav sidebar={sidebar}>
                        <SidebarWrap>
                            {SidebarData.map((item, index) => {
                                return (
                                    <SubMenu
                                        item={item}
                                        key={index}
                                        menuRef={index*10}
                                        selectedIndex={selectedMetricIndex}
                                        setActiveMetric={setActiveMetric}
                                        activeMetric={activeMetric}
                                        activeAirport={activeAirport}
                                        setActiveAirport={setActiveAirport}
                                        setAirportSelectedIndex={setAirportSelectedIndex}
                                        enabledAirports={enabledAirports}
                                        handleClick={handleMetricClick}
                                        currentUser={currentUser}
                                    />
                                );
                            })}
                        <AirportBox>
                            <AirportSearch menuRef={100*10}
                                           selectedIndex={selectedAirportIndex}
                                           activeAirport={activeAirport}
                                           setActiveAirport={setActiveAirport}
                                           activeMetric={activeMetric}
                                           handleClick={handleAirportClick}
                                           airportDataList={airportDataList}
                                           setActiveMetric={setActiveMetric}
                                           setMetricSelectedIndex={setMetricSelectedIndex}
                                           summaryMetricName={summaryMetricName}
                                           summaryMetricIndex={summaryMetricIndex}
                                           enabledAirports={enabledAirports}
                                           currentUser={currentUser}/>
                        </AirportBox>
                        </SidebarWrap>
                    </SidebarNav>
                    <ContentLayout sidebar={sidebar} selectedMetricIndex={selectedMetricIndex} revealFlag={showAirportCarouselFlag}>
                        {children}
                    </ContentLayout>
                </MasterLayout>
            </IconContext.Provider>
        </>
    );
};


export default NavLayout;
